import { formatDate, getCurrentDate } from "@taabl/common-lib/calculators/date";
import { formatCurrency } from "@taabl/common-lib/calculators/money";
import { round } from "@taabl/common-lib/utils";
import React, { useEffect, useState } from "react";
import { Constants } from "../../libs/Constants";
import RepayLoanButton from "../EmployeeHome/RepayLoanButton";
import { LoanTransactionModal } from "./LoanTransactionModal";
const moment = require("moment");

const ProfitSummary = ({ summary, userObj, transactions, refresh }) => {
  const [totalProfit, setTotalProfit] = useState(0);
  const [showRepayModal, setShowRepayModal] = useState(false);
  const [closingPeriodDetails, setClosingPeriodDetails] = useState(null);

  useEffect(() => {
    if (summary && summary.profitSummary && summary.profitSummary.length > 0) {
      calculateProfit();
      calculateClosingPeriodDetails();
    }
  }, [summary]);

  function calculateClosingPeriodDetails() {
    if (summary.profitSummary && summary.nearestClosingPeriod) {
      let nearestClosingPeriod = summary.nearestClosingPeriod;
      let closingPeriodSummary = summary.profitSummary.find(
        (s) => s.periodStartDate === nearestClosingPeriod.periodStartdate
      );
      let today = getCurrentDate(false);
      let cpd = {
        periodStartdate: nearestClosingPeriod.periodStartdate,
        periodEnddate: nearestClosingPeriod.periodEnddate,
        periodClosingDateDiff: moment
          .utc(nearestClosingPeriod.periodEnddate)
          .diff(today, "days"),
        repayDate: moment
          .utc(nearestClosingPeriod.periodEnddate)
          .add(5, "days"),
        periodProfit: closingPeriodSummary?.profit || 0,
        totalLoanBalance: closingPeriodSummary?.loan || 0,
      };
      setClosingPeriodDetails(cpd);
    }
  }

  function calculateProfit() {
    setTotalProfit(
      summary?.profitSummary?.reduce((acc, current) => {
        if (current?.profit) {
          acc += current.profit;
        }
        return acc;
      }, 0)
    );
  }

  useEffect(() => {
    function load() {
      if (!showRepayModal && isNotificationToRePay()) {
        setShowRepayModal(true);
      }
    }
    load();
  }, [closingPeriodDetails, transactions]);

  const getLoanAmount = () => {
    return transactions?.results?.reduce((acc, current) => {
      if (current.amount) {
        acc += current.amount.value;
      }
      if (current.fee) {
        acc += current.fee;
      }
      return acc;
    }, 0);
  };

  const isNotificationToRePay = () => {
    return (
      closingPeriodDetails?.periodClosingDateDiff <= 0 &&
      round(getLoanAmount()) > 0
    );
  };
  return (
    <div className="avere-part d-flex flex-column flex-md-row font-secondary justify-content-between align-content-center p-4 fw-bold">
      <div>
        <div className="text-gray">Total Net Profits</div>
        <div className="font-primary font-size-22 text-orange">
          {formatCurrency(totalProfit)}
        </div>
      </div>
      <div>
        <div className="text-gray fw-bold">Next Stock Issue Date</div>
        {summary && (
          <div className="font-primary font-size-22 text-orange">
            {formatDate(
              summary?.nearestUpcomingPeriod?.periodStartdate,
              Constants.DATEFORMAT.MMDDYYYY
            )}
          </div>
        )}
      </div>
      <div>
        <div className="text-gray fw-bold d-flex justify-content-center">
          Current Loan Balance + Fee{" "}
          <LoanTransactionModal transactions={transactions} />
        </div>
        <div className="font-primary font-size-22 text-orange">
          {formatCurrency(getLoanAmount())}
        </div>
        {isNotificationToRePay() && (
          <RepayLoanButton
            closingPeriodDetails={closingPeriodDetails}
            loanAmount={getLoanAmount()}
            userObj={userObj}
            refresh={refresh}
          />
        )}
      </div>
    </div>
  );
};

export default ProfitSummary;
